import ko from "knockout";
import { CloseCallback } from "flow/api/types";
import config from "flow/config";
import manifestManager from "flow/utils/manifestManager";
import * as systemInformationManager from "flow/systeminfo/systemInformationManager";
import bind from "bind-decorator";

export interface ISystemInformationViewContext {
    guid: string;
    title: string;
    text: string;
}

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.systemInformationDialog,
        isDialog: true,
        reuseInstance: false,
        useFormValidation: false,
        namespace: "default",
        viewModelId: "flow/viewModels/SystemInformationDialog",
        viewUrl: "text!flow/viewModels/SystemInformationDialog.html"
    }
]);

export default class SystemInformationDialog {
    private guid: string;
    componentTitle = ko.observable<string>();
    text = ko.observable<string>();
    onClose: CloseCallback;
    private focusObservable = ko.observable();
    private closing = false;

    activate(viewContext: ISystemInformationViewContext, onClose: CloseCallback) {
        this.guid = viewContext.guid;
        this.componentTitle(viewContext.title);
        this.text(viewContext.text || "");

        this.onClose = onClose;
        this.focusObservable(true);

        systemInformationManager.addCloseSubscriber(this.closedInOtherTab);
    }

    @bind
    closedInOtherTab(guid: string) {
        if (this.guid === guid && !this.closing) {
            this.onClose();
        }
    }

    onOk() {
        this.closing = true;
        systemInformationManager.closeInAllTabs(this.guid);
        this.onClose();
    }

    onDestroy() {
        systemInformationManager.removeCloseSubscriber(this.closedInOtherTab);
    }

    commands = ko.observableArray([
        {
            text: "OK",
            click: this.onOk.bind(this),
            focusObs: this.focusObservable
        }
    ]);
}
